import script from "./SearchSimple.vue?vue&type=script&setup=true&lang=ts"
export * from "./SearchSimple.vue?vue&type=script&setup=true&lang=ts"

import "./SearchSimple.vue?vue&type=style&index=0&id=a558e828&lang=scss&scoped=true"

import exportComponent from "C:\\Users\\a-okamura\\Documents\\project\\JuchuAppFront\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-a558e828"]])

export default __exports__